import { z } from 'zod';
import type { Base } from '../base/base.entity.model';
import * as FlatModels from '../../internal';

export const HistoryControlEntityStateItemModelSchema = z.object({
  itemJson: z.string(),
});

export type HistoryControlEntityStateItemModel = z.infer<typeof HistoryControlEntityStateItemModelSchema>;

export interface HistoryControlEntityStateModel<T extends Base | FlatModels.UserEntityModels.User> extends FlatModels.EntityStatesModels.EntityStateModel<T> {
  entities: { [id: string]: T };
  snapshots: { [id: string]: HistoryControlEntityStateItemModel };
}